import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import EnquiryModal from "./components/EnquiryModal";
import FloatingActions from "./components/FloatingActions";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Gallery from "./pages/Gallery";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";

const ROUTER_BASENAME =
  typeof window !== "undefined" ? window.__SANGGAVAI_BASE_PATH__ || "" : "";

function App() {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [enquiryContext, setEnquiryContext] = useState(null);

  const openEnquiry = (context = null) => {
    setEnquiryContext(context);
    setEnquiryOpen(true);
  };

  // Auto-trigger popup once per session after 8s
  useEffect(() => {
    const shown = sessionStorage.getItem("sanggavai_enquiry_shown");
    if (shown) return;
    const t = setTimeout(() => {
      setEnquiryOpen(true);
      sessionStorage.setItem("sanggavai_enquiry_shown", "1");
    }, 8000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      <BrowserRouter basename={ROUTER_BASENAME}>
        <ScrollToTop />
        <Header onEnquire={() => openEnquiry()} />
        <main>
          <Routes>
            <Route path="/" element={<Home onEnquire={openEnquiry} />} />
            <Route path="/about" element={<About onEnquire={openEnquiry} />} />
            <Route path="/projects" element={<Projects onEnquire={openEnquiry} />} />
            <Route path="/projects/ongoing" element={<Projects onEnquire={openEnquiry} />} />
            <Route path="/projects/completed" element={<Projects onEnquire={openEnquiry} />} />
            <Route path="/projects/:slug" element={<ProjectDetail onEnquire={openEnquiry} />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/careers" element={<Careers onEnquire={openEnquiry} />} />
            <Route path="/contact" element={<Contact onEnquire={openEnquiry} />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
        <EnquiryModal
          open={enquiryOpen}
          onOpenChange={setEnquiryOpen}
          context={enquiryContext}
        />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
